import * as React from 'react';
import OTPInput from 'react-otp-input';
import { cn } from '@/utils';

interface OtpInputProps {
  value: string;
  onChange: (value: string) => void;
  numInputs?: number;
  disabled?: boolean;
  className?: string;
}

const OtpInput = React.forwardRef<HTMLDivElement, OtpInputProps>(
  ({ value, onChange, numInputs = 6, disabled = false, className }, ref) => {
    return (
      <div ref={ref} className={cn('w-full mt-4', className)}>
        <OTPInput
          value={value}
          onChange={onChange}
          numInputs={numInputs}
          inputType="tel"
          containerStyle="flex w-full justify-between gap-2 sm:gap-4"
          renderInput={(inputProps, index) => (
            <input
              {...inputProps}
              key={index}
              inputMode="numeric"
              className={cn(
                'flex-1 min-w-0 h-10 sm:h-12',
                'border text-center text-lg sm:text-xl font-bold',
                'text-white bg-background border-white',
                disabled && 'cursor-not-allowed opacity-50'
              )}
            />
          )}
        />
      </div>
    );
  }
);

OtpInput.displayName = 'OtpInput';

export { OtpInput };
